<!-- 大屏编排对阵 -->
<template>
   <div class="content">
    <div class="title">        
        <div>{{titlePub}}</div>
        <div class="round-title">第{{round}}轮编排</div>
    </div>    
    <div v-if="isReady" class="custom-table2">
        <div class="flex-row-1" v-if="pubType === '1'">
            <el-table class="custom-table" 
                v-if="firstTableData.length > 0"
                :data="firstTableData"
                :row-class-name="tableRowClassName"
                style="" border>
                <el-table-column
                    prop="deskNo"
                    label="桌号"
                    width="100"
                    align="center"  
                    >
                </el-table-column>
                <el-table-column
                    prop="usernameW"
                    label="东"   
                    align="center"                 
                >
                <template slot-scope="scope" >
                    <div>
                        <span :class="scope.row.statusW === '弃权'? 'gray-row':''"> {{ scope.row.usernameW }}</span>
                    </div>
                </template>
                </el-table-column>    
                <el-table-column
                    prop="usernameE"
                    label="西"   
                    align="center"                 
                >
                <template slot-scope="scope" >
                    <div>
                        <span :class="scope.row.statusE === '弃权'? 'gray-row':''"> {{ scope.row.usernameE }}</span>
                    </div>
                </template>
                </el-table-column>   
                <el-table-column
                    prop="usernameS"
                    label="南"   
                    align="center"                 
                >
                <template slot-scope="scope" >
                    <div>
                        <span :class="scope.row.statusS === '弃权'? 'gray-row':''"> {{ scope.row.usernameS }}</span>
                    </div>
                </template>
                </el-table-column>      
                <el-table-column
                    prop="usernameN"
                    label="北"
                    align="center"  
                >
                <template slot-scope="scope" >
                    <div>
                        <span :class="scope.row.statusN === '弃权'? 'gray-row':''"> {{ scope.row.usernameN }}</span>
                    </div>
                </template>
                </el-table-column>  
            </el-table>
            <el-table class="custom-table" 
                v-if="secondTableData.length > 0"
                :data="secondTableData"
                :row-class-name="tableRowClassName"
                style="margin-left: 15px;" border>
                <el-table-column
                    prop="deskNo"
                    label="桌号"
                    width="100"
                    align="center"  
                    >
                </el-table-column>
                <el-table-column
                    prop="usernameW"
                    label="东"   
                    align="center"                 
                >
                <template slot-scope="scope" >
                    <div >
                        <span :class="scope.row.statusW === '弃权'? 'gray-row':''"> {{ scope.row.usernameW }}</span>
                    </div>
                </template>
                </el-table-column>    
                <el-table-column
                    prop="usernameE"
                    label="西"   
                    align="center"                 
                >
                <template slot-scope="scope" >
                    <div >
                        <span :class="scope.row.statusE === '弃权'? 'gray-row':''"> {{ scope.row.usernameE }}</span>
                    </div>
                </template>
                </el-table-column>   
                <el-table-column
                    prop="usernameS"
                    label="南"   
                    align="center"                 
                >
                <template slot-scope="scope" >
                    <div>
                        <span :class="scope.row.statusS === '弃权'? 'gray-row':''"> {{ scope.row.usernameS }}</span>
                    </div>
                </template>
                </el-table-column>      
                <el-table-column
                    prop="usernameN"
                    label="北"
                    align="center"  
                >
                <template slot-scope="scope" >
                    <div>
                        <span :class="scope.row.statusN === '弃权'? 'gray-row':''"> {{ scope.row.usernameN}}</span>
                    </div>
                </template>
                </el-table-column>  
            </el-table>  
            <el-table class="custom-table" 
                v-if="thirdTableData.length > 0"
                :data="thirdTableData"
                :row-class-name="tableRowClassName"
                style="margin-left: 15px;" border>
                <el-table-column
                    prop="deskNo"
                    label="桌号"
                    width="100"
                    align="center"  
                    >
                </el-table-column>
                <el-table-column
                    prop="usernameW"
                    label="东"   
                    align="center"                 
                >
                <template slot-scope="scope" >
                    <div >
                        <span :class="scope.row.statusW === '弃权'? 'gray-row':''"> {{ scope.row.usernameW }}</span>
                    </div>
                </template>
                </el-table-column>    
                <el-table-column
                    prop="usernameE"
                    label="西"   
                    align="center"                 
                >
                <template slot-scope="scope" >
                    <div >
                        <span :class="scope.row.statusE === '弃权'? 'gray-row':''"> {{ scope.row.usernameE }}</span>
                    </div>
                </template>
                </el-table-column>   
                <el-table-column
                    prop="usernameS"
                    label="南"   
                    align="center"                 
                >
                <template slot-scope="scope" >
                    <div>
                        <span :class="scope.row.statusS === '弃权'? 'gray-row':''"> {{ scope.row.usernameS }}</span>
                    </div>
                </template>
                </el-table-column>      
                <el-table-column
                    prop="usernameN"
                    label="北"
                    align="center"  
                >
                <template slot-scope="scope" >
                    <div>
                        <span :class="scope.row.statusN === '弃权'? 'gray-row':''"> {{ scope.row.usernameN}}</span>
                    </div>
                </template>
                </el-table-column>  
            </el-table>            
        </div>
        <div class="flex-row-1" v-else>
            <el-table class="custom-table custom-table2"
            :data="firstTableData"
            :row-class-name="tableRowClassName"
            style="width: 60%" border>           
            <el-table-column
                prop="usernameWE"
                label="东西"   
                align="center"                 
            >
            <template slot-scope="scope" >
                <div>
                    <span :class="scope.row.statusWE === '弃权'? 'gray-row':''"> {{ scope.row.usernameWE }}</span>
                </div>
            </template>
            </el-table-column>  
            <el-table-column
                prop="deskNo"
                label="桌号"
                width="100"
                align="center"  
                >
            </el-table-column>     
            <el-table-column
                prop="usernameSN"
                label="南北"
                align="center"  
            >
            <template slot-scope="scope">
                <div>
                    <span :class="scope.row.statusSN === '弃权'? 'gray-row':''"> {{ scope.row.usernameSN}}</span>
                </div>
            </template>
            </el-table-column>  
        </el-table>
        <el-table class="custom-table"
            v-if="secondTableData.length>0"
            :data="secondTableData"
            :row-class-name="tableRowClassName"
            style="width: 60%;margin-left: 15px;" border>            
            <el-table-column
                prop="usernameWE"
                label="东西"   
                align="center"                 
            >
            <template slot-scope="scope" >
                <div>
                    <span :class="scope.row.statusWE === '弃权'? 'gray-row':''"> {{ scope.row.usernameWE }}</span>
                </div>
            </template>
            </el-table-column>   
            <el-table-column
                prop="deskNo"
                label="桌号"
                width="100"
                align="center"  
                >
            </el-table-column>    
            <el-table-column
                prop="usernameSN"
                label="南北"
                align="center"  
            >
            <template slot-scope="scope" >
                <div>
                    <span :class="scope.row.statusSN === '弃权'? 'gray-row':''"> {{ scope.row.usernameSN }}</span>
                </div>
            </template>
            </el-table-column>  
        </el-table>
        <el-table class="custom-table"
            v-if="thirdTableData.length>0"
            :data="thirdTableData"
            :row-class-name="tableRowClassName"
            style="width: 60%;margin-left: 15px;" border>           
            <el-table-column
                prop="usernameWE"
                label="东西"   
                align="center"                 
            >
            <template slot-scope="scope" >
                <div>
                    <span :class="scope.row.statusWE === '弃权'? 'gray-row':''"> {{ scope.row.usernameWE }}</span>
                </div>
            </template>
            </el-table-column> 
            <el-table-column
                prop="deskNo"
                label="桌号"
                width="100"
                align="center"  
                >
            </el-table-column>     
            <el-table-column
                prop="usernameSN"
                label="南北"
                align="center"  
            >
            <template slot-scope="scope" >
                <div>
                    <span :class="scope.row.statusSN === '弃权'? 'gray-row':''"> {{ scope.row.usernameSN }}</span>
                </div>
            </template>
            </el-table-column>  
        </el-table>
        </div> 
    </div>
   </div>
</template>
<script>
export default {
    data() {
        return {
            titlePub: '',
            dataList: [],
            firstTableData: [],
            secondTableData: [],
            thirdTableData: [],
            tableData: [],
            isShow: false,
            isReady: false,
            round: 1
        }
    },
    created() {        
        this.pubId = this.$route.query.id
        this.pubType = this.$route.query.type
        this.getTitle()
    },
    mounted() {
        document.addEventListener('click', this.toggleFullScreen);
    },
    computed:{
        
    },
    methods: {
        tableRowClassName({row, rowIndex}){
            // 一桌一种颜色
            if(row.deskNo % 2){
                return 'white-row'
            }else{
                return  'green-row'
            }
        },
        // 赛事编排对阵查询
        initData(){
            let params = {
                opcode: this.$code.PubArrange,
                i_serial_mark: this.pubId,
                i_round: this.round,
            }
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.isReady = true
                    if(result.length > 0){
                        let arr  = result.map(item=>{
                        let username = this.pubType === '2'? `${item['选手名称']}/${item['搭档名称']}` : item['选手名称']
                            return{
                                deskNo: item['桌号'],
                                id: item['选手编号'],
                                username: username,
                                phone: item['选手手机号'],
                                company: item['协会（俱乐部）'],
                                userId: item['选手账号'],
                                seat: item['座位'],
                                matchStatus: item['参赛状态'],
                            }
                        })
                        this.dataList = this.selectDeskNo(arr)
                        // console.log('编排2',this.dataList)

                        let  playerArr  = JSON.parse(JSON.stringify(this.dataList))
                        if(playerArr.length > 20){                           
                            // const splitSize = Math.round(playerArr.length / 2); 
                            // console.log('向上取整',splitSize,playerArr.length / 2)
                            // this.firstTableData = playerArr.slice(0, splitSize);  
                            // this.secondTableData = playerArr.slice(splitSize); 
                            // console.log(playerArr.length) 
                            if(playerArr.length > 46){
                               const chunkSize =  Math.ceil(playerArr.length / 3)
                               const chunkedArrays = this.splitArrayIntoChunks(playerArr, chunkSize);
                               this.firstTableData = chunkedArrays[0]
                               this.secondTableData = chunkedArrays[1]
                               this.thirdTableData = chunkedArrays[2]
                               console.log(chunkedArrays)
                            }else{
                                const splitSize = Math.round(playerArr.length / 2); 
                                // console.log('向上取整',splitSize,playerArr.length / 2)
                                this.firstTableData = playerArr.slice(0, splitSize);  
                                this.secondTableData = playerArr.slice(splitSize);
                                this.thirdTableData = []
                            }
                        }else{
                            // console.log('2',playerArr.length)
                            this.firstTableData = playerArr
                            this.secondTableData = []
                        }

                        this.tableData = result.map(item=>{
                        let username = this.pubType === '2'? `${item['选手名称']}/${item['搭档名称']}` : item['选手名称']
                            return{
                                deskNo: item['桌号'],
                                id: item['选手编号'],
                                username: username,
                                phone: item['选手手机号'],
                                company: item['协会（俱乐部）'],
                                userId: item['选手账号'],
                                seat: item['座位'],
                                round: item['第几轮'],
                                matchStatus: item['参赛状态'],
                            }
                        })
                    }else{
                        this.$message.error('请先设置')
                    }                    
                }
            })
        },
        // 创建一个函数来均分数组
        splitArrayIntoChunks(array, chunkSize){
            const chunks = [];
            for (let i = 0; i < array.length; i += chunkSize) {
                chunks.push(array.slice(i, i + chunkSize));
            }
            return chunks;
        },
        selectDeskNo(arr){
             let result = []
             arr.forEach(item => {
                 if(!result.some(i => i.deskNo === item.deskNo )){
                        let newArr = arr.filter(user => user.deskNo === item.deskNo)
                        let usernameWE = ''
                        let usernameSN = ''
                        let usernameW= ''
                        let usernameE= ''
                        let usernameS= ''
                        let usernameN= ''
                        if(this.pubType === '1'){
                            usernameW = (newArr.filter(i =>  i.seat.includes('东')))[0].username
                            usernameE = (newArr.filter(i =>  i.seat.includes('西')))[0].username
                            usernameS = (newArr.filter(i =>  i.seat.includes('南')))[0].username
                            usernameN = (newArr.filter(i =>  i.seat.includes('北')))[0].username
                        }else{
                            usernameWE = (newArr.filter(i =>  i.seat.includes('东')))[0].username 
                            usernameSN = (newArr.filter(i =>  i.seat.includes('北')))[0].username
                        }  
                        if(this.pubType === '1'){
                            result.push({
                                deskNo: item.deskNo,
                                usernameW: usernameW,
                                usernameE: usernameE,  
                                usernameS: usernameS,
                                usernameN: usernameN,
                                playerNo:  item.id,
                                statusW: (newArr.filter(i =>  i.seat.includes('东')))[0].matchStatus,
                                statusE: (newArr.filter(i =>  i.seat.includes('西')))[0].matchStatus,
                                statusS: (newArr.filter(i =>  i.seat.includes('南')))[0].matchStatus,
                                statusN: (newArr.filter(i =>  i.seat.includes('北')))[0].matchStatus,                   
                            })
                        }else{
                            result.push({
                                deskNo: item.deskNo,
                                usernameWE: usernameWE,
                                usernameSN: usernameSN, 
                                playerNo:  item.id,
                                statusWE: (newArr.filter(i =>  i.seat.includes('东')))[0].matchStatus,
                                statusSN: (newArr.filter(i =>  i.seat.includes('北')))[0].matchStatus,                               
                            })
                        }                     
                       
                 }
             });
             return result
         }, 
        getTitle(){
            let params = {
                opcode: this.$code.PublishQuery,
                i_serial_mark: this.pubId,
                c_status: '',
                v_type: '',
                v_theme: '',
                start_date: '',
                end_date: '',
                pagesize: 10,
                page: 1,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    let list = result.map(item=>{                        
                        return{
                            title: item['主题'],
                            round: item['比赛轮数']+1,
                            maxRound: item['轮数'],
                        }
                    })
                    this.titlePub = list[0].title 
                    this.round = list[0].round <= list[0].maxRound ? list[0].round : list[0].maxRound
                    setTimeout(()=>{
                        this.initData()
                    })
                }
            })
        },
        toggleFullScreen(){
            if (!document.fullscreenElement) {
                this.$help.enterFullScreen();
            } else {
                this.$help.exitFullScreen();
            }
        }, 
    },
    beforeDestroy() {
        // 在实例销毁前移除事件监听
        document.removeEventListener('click', this.toggleFullScreen);
    },
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.content{
    width: 100%;
    overflow: auto;
}
.title{
    font-size: 28px;
    padding: 8px 0;
    text-align: center;
    color: gold;
    background-color: #de2c11;
}
.round-title{
    font-size: 24px;
    text-align: center;
    margin-top: 4px;
}
.custom-table >>> .el-table__header-wrapper tr th{
    // font-size: 20px;
    // color: #000;
}

table {
    width: 100%;
    border-collapse: collapse;
  }
  th, td {
    border: 1px solid #999;
    padding: 8px;
    text-align: left;
    font-size: 20px;
  }
  tr:nth-child(even) {
    background-color: #bbffbb;
  }
  thead th {
    background-color: #f2f2f2;
    font-size: 18px;
    text-align: center;
  }
  .table-label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
  }
  .el-table >>> .green-row{
    background-color: #bbffbb
  }
  .el-table >>> .white-row{
    background-color: #f0f9eb;
  }
  .el-table >>> .gray-row{
    background-color: #b9b5b5;
}
.content{
    margin: 0 auto
}

.custom-table2 >>> .el-table__cell {
    padding: 0 !important;
    font-size: 34px;
}
.custom-table .el-table__cell .cell{
    font-size: 34px;
}
.custom-table >>> .cell{
    padding: 8px 0 !important;
    font-size: 34px ;
    font-family: '黑体';
    // font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/views/fullScreen/fullArrange.vue